import {KTIcon} from '../../../../_metronic/helpers'
import {INotification} from '../_model'

type Props = {
  notification: INotification
  handleShow: (id: number) => void
}

const NotificationActionCell = ({notification, handleShow}: Props) => {
  const onHandleClick = () => handleShow(notification.id)

  const buttonCursor = notification.status === '1' ? 'not-allowed' : 'pointer'

  return (
    <div className='text-end' style={{cursor: buttonCursor}} onClick={onHandleClick}>
      <KTIcon
        iconName={notification.status === '1' ? 'eye-slash' : 'eye'}
        className='fs-2x text-gray-800'
      />
    </div>
  )
}

export default NotificationActionCell
